import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  loadingSpinner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
}));
